import {
  Box,
  Button,
  Card,
  CardHeader,
  Checkbox,
  Divider,
  FormLabel,
  Grid,
  Input,
  List,
  ListItem,
  ListItemText,
  Modal,
} from "@mui/material";
import { toast, Toaster } from "react-hot-toast";
import PageHeader from "../components/ui/PageHeader";
import CustomInput from "../components/ui/CustomInput";

import { useRef, useState, useEffect } from "react";
import axios from "../api/axiosClient";
import { useSelector, useDispatch } from "react-redux";
import PageForm from "../components/ui/PageForm";
import SaveIcon from "@mui/icons-material/Save";
import DownloadIcon from "@mui/icons-material/Download";
import CustomRadioButton from "../components/ui/CustomRadioButton";
import DownloadExcelModal from "../components/Modals/DownloadExcelModal";

import { useLoading } from "../components/LoadingContext";
import {
  handleError,
  getDateAsISOString,
  getFilledOrNullString,
  getFilledOrEmptyArray
} from "../services/serviceBase";

import { getExcelReports, runReportDownload, getExcelReportFieldSets } from "../services/exportService";
import * as apiService from "../services/apiService";

import { useIntl } from "react-intl";


function not(a, b) {
  return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
  return a.filter((value) => b.indexOf(value) !== -1);
}

function union(a, b) {
  return [...a, ...not(b, a)];
}

const ExcelReports = () => {
  const withStealthFlow = useSelector((state) => state.common.withStealthFlow);
  const intl = useIntl();
  const [excelReports, setExcelReports] = useState([]);
  const [selectedReport, setSelctedReport] = useState("");

  const [excelReportFiledsets, setExcelReportFiledsets] = useState([]);
  const [selectedFieldset, setSelectedFieldset] = useState("");
  const [fieldSetCanChange, setFieldSetCanChange] = useState(true);

  const [SAPCustomers, setSAPCustomers] = useState([]);
  const [STEALTHCustomers, setSTEALTHCustomers] = useState([]);
  const [selectedSAPCustomers, setSelectedSAPCustomers] = useState([]);
  const [selectedSTEALTHCustomers, setSelectedSTEALTHCustomers] = useState([]);

  const [states, setStates] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [countries, setCountries] = useState([]);

  const [creationFromDate, setCreationFromDate] = useState(null);
  const [creationToDate, setCreationToDate] = useState(null);

  const [checkInFromDate, setCheckInFromDate] = useState(null);
  const [checkInToDate, setCheckInToDate] = useState(null);

  const [endQCFromDate, setEndQCFromDate] = useState(null);
  const [endQCToDate, setEndQCToDate] = useState(null);

  const [closingFromDate, setClosingFromDate] = useState(null);
  const [closingToDate, setClosingToDate] = useState(null);

  const company = useSelector((state) => state.common.company);

  const [includeClosed, setIncludeClosed] = useState(false);
  const [year, setYear] = useState(new Date().getFullYear());
  const [number, setNumber] = useState(null);
  const [split, setSplit] = useState(null);

  const [sku, setSku] = useState(null);
  const [styleCode, setStyleCode] = useState(null);
  const [fabricCode, setFabricCode] = useState(null);
  const [colorCode, setColorCode] = useState(null);

  const [selectedStates, setselectedStates] = useState([]);
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);

  const [inboundDelivery, setInboundDelivery] = useState('');
  const [jdaLocation, setJdaLocation] = useState('');
  const [sapSender, setSapSender] = useState('');
  const [selectedOutcomes, setSelectedOutcomes] = useState([]);
  const [outcomes, setOutcomes] = useState([]);

  const [modalName, setModalName] = useState("");

  const [tableHeight, setTableHeigth] = useState(260);
  const [fields, setFields] = useState([]);
  const [checked, setChecked] = useState([]);
  const [availableColumns, setAvailableColumns] = useState([]);
  const [chosenColumns, setChosenColumns] = useState([]);

  const leftChecked = intersection(checked, availableColumns);
  const rightChecked = intersection(checked, chosenColumns);

  const [openSaveModal, setOpenSaveModal] = useState(false);
  const handleCloseSaveModal = () => setOpenSaveModal(false);

  const [downloadLink, setDownloadLink] = useState("");
  const [openDownloadModal, setOpenDownloadModal] = useState(false);

  const user = useSelector((state) => state.auth.user);
  const isAdminUser = user?.profile?.default_role == "Admin";

  const { setLoading } = useLoading();

  const resizeTable = () => {
    var fromHeight = document.querySelector("#form").clientHeight;
    var pageHeight = window.innerHeight;
    var tableHeight = pageHeight - fromHeight - 400;
    setTableHeigth(tableHeight);
  };

  useEffect(() => {
    window.addEventListener("resize", resizeTable);
    return () => {
      window.removeEventListener("resize", resizeTable);
    };
  }, []);

  const handletrasitionEnd = () => {
    resizeTable();
  };

  const handleDatesValidation = () => {
    if (creationFromDate != null && creationToDate != null && creationFromDate > creationToDate) {
      setCreationFromDate(null);
      setCreationToDate(null);
      toast.error(
        intl.formatMessage({ id: "Error.StartDateLaterThenEndDate" })
      );
    } else if (creationFromDate != null) {
      setCreationFromDate(creationFromDate);
    } else if (creationToDate != null) {
      setCreationToDate(creationToDate);
    }
  };

  useEffect(() => {
    handleDatesValidation();
  }, [creationFromDate, creationToDate]);

  const modalStyle = {
    position: "absolute",
    top: "20%",
    left: "50%",
    width: "400px",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    p: 4,
    borderRadius: 2,
  };

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const numberOfChecked = (items) => intersection(checked, items).length;

  const handleToggleAll = (items) => () => {
    if (numberOfChecked(items) === items.length) {
      setChecked(not(checked, items));
    } else {
      setChecked(union(checked, items));
    }
  };

  const handleCheckedRight = () => {
    setChosenColumns(chosenColumns.concat(leftChecked));
    setAvailableColumns(not(availableColumns, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    setAvailableColumns(availableColumns.concat(rightChecked));
    setChosenColumns(not(chosenColumns, rightChecked));
    setChecked(not(checked, rightChecked));
  };

  const handleDossierAgeChange = (dossierAge) => {
    if (dossierAge !== undefined && dossierAge !== "") {
      setDossierAge(dossierAge);
    } else {
      setDossierAge("");
    }
  };

  const [dossierAge, setDossierAge] = useState("");
  const [checkRadioRed, setCheckRadioRed] = useState(false);
  const [checkRadioOrange, setCheckRadioOrange] = useState(false);
  const [checkRadioWhite, setCheckRadioWhite] = useState(false);

  const handleCheckRadioRed = () => {
    if (!checkRadioRed) {
      setCheckRadioRed(true);
      setCheckRadioOrange(false);
      setCheckRadioWhite(false);
      setDossierAge("Red");
    } else {
      setCheckRadioRed(false);
      setDossierAge("");
    }
  };

  const handleCheckRadioOrange = () => {
    if (!checkRadioOrange) {
      setCheckRadioOrange(true);
      setCheckRadioRed(false);
      setCheckRadioWhite(false);
      setDossierAge("Orange");
    } else {
      setCheckRadioOrange(false);
      setDossierAge("");
    }
  };

  const handleCheckRadioWhite = () => {
    if (!checkRadioWhite) {
      setCheckRadioWhite(true);
      setCheckRadioRed(false);
      setCheckRadioOrange(false);
      setDossierAge("Blue");
    } else {
      setCheckRadioWhite(false);
      setDossierAge("");
    }
  };

const getReports = async () => {
  setLoading(true);
  getExcelReports(
    "EXP",
    (response) => {
      setLoading(false);
      var selectItems = [];
      if (response !== undefined && response != null) {
        response.map((x) => {
          selectItems.push({
            value: x.idExcelReport,
            text: x.excelReportName,
          });
        });
      }
      setExcelReports(selectItems);
    },
    (error) => {
      setLoading(false);
      handleError(error, intl);
    }
  );
};

  const getCustomers = async () => {
    setLoading(true);
    let params = new URLSearchParams();
    params.append("IdCompany", `${company}`);
    var url = "/masterdata/Customers" + "?" + params.toString();

    axios
      .get(url)
      .then((response) => {
        setLoading(false);
        var selectItems = [];
        if (response.data !== undefined && response.data != null) {
          response.data.map((x) => {
            selectItems.push({
              text: `${x.customerCode} - ${x.description}`,
              value: x.idCustomer,
            });
          });
        }
        setSAPCustomers(selectItems);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const getSTEALTHCustomers = async () => {
    setLoading(true);
    let params = new URLSearchParams();
    params.append("IdCompany", `${company}`);
    var url =
      "/masterdata/Customers/STEALTHCustomers" + "?" + params.toString();

    axios
      .get(url)
      .then((response) => {
        setLoading(false);
        var selectItems = [];
        if (response.data !== undefined && response.data != null) {
          response.data.map((x) => {
            selectItems.push({
              text: `${x.customerCode} - ${x.description}`,
              value: x.idCustomer,
            });
          });
        }
        setSTEALTHCustomers(selectItems);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const getStates = async () => {
    setLoading(true);
    axios
      .get("/masterdata/ReturnFileStates")
      .then((response) => {
        setLoading(false);
        var selectItems = [];
        if (response.data !== undefined) {
          response.data.map((x) => {
            selectItems.push({
              text: x.rfStateDescription,
              value: x.idRFState,
            });
          });
        }
        setStates(selectItems);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const getDepartments = async () => {
    setLoading(true);
    apiService.getDepartments(
      (response) => {
        setLoading(false);
        var selectDepartmentItems = [];
        if (response !== undefined) {
          response.map((x) => {
            selectDepartmentItems.push({ value: x.id, text: x.departmentCode });
          });
        }
        setDepartments(selectDepartmentItems);
      },
      (error) => {
        setLoading(false);
        handleError(error, intl);
      }
    );
  };

  const getCountries = async () => {
    setLoading(true);
    apiService.getCountries(
      (response) => {
        setLoading(false);
        var countrySelectItems = [];
        if (response !== undefined) {
          response.map((x) => {
            countrySelectItems.push({
              value: x.idCountry,
              text: x.countryDescription,
            });
          });
        }
        setCountries(countrySelectItems);
      },
      (error) => {
        setLoading(false);
        handleError(error, intl);
      }
    );
  };

  const getOutcomes = async () => {
    setLoading(true);
    apiService.getOutcomes(
      (response) => {
        setLoading(false);
        var selectedItems = [];
        if (response !== undefined) {
          response.map((x) => {
            selectedItems.push({
              value: x.idAnagQCOutcome,
              text: x.outcomeCode + ' - ' + x.description,
            });
          });
        }
        setOutcomes(selectedItems);
      },
      (error) => {
        setLoading(false);
        handleError(error, intl);
      }
    );
  };
  
  useEffect(() => {
    getReports();
    getCustomers();
    getSTEALTHCustomers();
    getStates();
    getDepartments();
    getCountries();
    getOutcomes();
  }, []);

  const getFieldSet = async () => {
    setLoading(true);
    getExcelReportFieldSets(
      selectedReport,
      (response) => {
        setLoading(false);
        var selectItems = [];
        if (response !== undefined && response != null) {
          response.map((x) => {
            selectItems.push({
              value: x.idExcelReportFieldSet,
              text: x.excelReportFieldSetName,
              canChange: x.canChange
            });
          });
        }
        setExcelReportFiledsets(selectItems);
      },
      (error) => {
        setLoading(false);
        handleError(error, intl);
      }
    );
  };

  const getFields = async () => {
    setLoading(true);
    axios
      .get("excelreports/" + selectedReport + "/fields")
      .then((response) => {
        setLoading(false);
        setFields(response.data);
        setAvailableColumns(response.data);
        setChosenColumns([]);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  useEffect(() => {
    if (
      selectedReport !== "" &&
      selectedReport !== undefined &&
      selectedReport !== null
    ) {
      getFieldSet();
      getFields();
    } else {
      setSelectedFieldset("");
      setExcelReportFiledsets([]);
      setFields([]);
      setAvailableColumns([]);
    }
  }, [selectedReport]);

  const getFieldsByFieldSet = async () => {
    setLoading(true);
    axios
      .get("excelreports/" + selectedReport + "/fieldset/" + selectedFieldset)
      .then((response) => {
        setLoading(false);
        var selectedColumns = [];
        if (response.data !== undefined && response.data != null) {
          response.data.map((x) => {
            selectedColumns.push(x.excelReportFieldSetMappingName);
          });
        }

        let newLeft = [];
        fields.map((x) => newLeft.push(x));

        selectedColumns.map((x) => {
          var leftIndex = newLeft.indexOf(x);
          newLeft.splice(leftIndex, 1);
        });

        setChosenColumns(selectedColumns);
        setAvailableColumns(newLeft);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleRun = () => {
    var allCustomers = getFilledOrEmptyArray(selectedSAPCustomers).concat(getFilledOrEmptyArray(selectedSTEALTHCustomers));

    var data = {
      IdExcelReportFieldSet: selectedFieldset,
      IdRFDepartmentList: getFilledOrEmptyArray(selectedDepartments),
      RFYear: getFilledOrNullString(year),
      RFNumber: getFilledOrNullString(number),
      RFSplit: getFilledOrNullString(split),
      IdCompany: company,
      IdCustomerList: allCustomers,
      IdRFStateList: getFilledOrEmptyArray(selectedStates),
      DateFrom: getDateAsISOString(creationFromDate),
      DateTo: getDateAsISOString(creationToDate),
      DossierAge: getFilledOrNullString(dossierAge),
      Shop: getFilledOrNullString(sapSender),
      JdaLocation: getFilledOrNullString(jdaLocation),
      IdCountry: getFilledOrNullString(selectedCountry), 
      CheckInDateFrom: getDateAsISOString(checkInFromDate),
      CheckInDateTo: getDateAsISOString(checkInToDate),
      EndQCDateFrom: getDateAsISOString(endQCFromDate),
      EndQCDateTo: getDateAsISOString(endQCToDate),
      ClosingDateFrom: getDateAsISOString(closingFromDate),
      ClosingDateTo: getDateAsISOString(closingToDate),
      SAPInboundDelivery: getFilledOrNullString(inboundDelivery),
      SKU: getFilledOrNullString(sku),
      StyleCode: getFilledOrNullString(styleCode),
      FabricCode: getFilledOrNullString(fabricCode),
      ColorCode: getFilledOrNullString(colorCode),
      IdAnagQCOutcomes: getFilledOrEmptyArray(selectedOutcomes),
      IncludeRFClosed: includeClosed
    };

    setLoading(true);

    runReportDownload(
      selectedReport,
      data,
      (response) => {
        setLoading(false);
        setDownloadLink(response);
      },
      (error) => {
        setLoading(false);
        handleError(error, intl);
      }
    );
  };

  const handleSave = () => {
    if (selectedFieldset != undefined && selectedFieldset != "") {
      var selectedFieldSetItem = excelReportFiledsets.find(
        (x) => x.value == selectedFieldset
      );
      var selecteFieldSetName = selectedFieldSetItem.text;
      setModalName(selecteFieldSetName);
    } else {
      setModalName("");
    }

    setOpenSaveModal(true);
  };

  const handleChangeModalName = (e) => {
    setModalName(e.currentTarget.value);
  };

  const handleSaveModal = () => {
    if (modalName == undefined || modalName == "") {
      toast.error(intl.formatMessage({ id: "ExcelReports.FieldSetMandatory" }));
      return;
    }

    var model = {
      fieldSetName: modalName,
      fields: chosenColumns,
    };

    if (
      selectedFieldset !== "" &&
      selectedFieldset !== null &&
      selectedFieldset !== undefined
    ) {
      setLoading(true);
      let url =
        "/excelreports/" + selectedReport + "/fieldset/" + selectedFieldset;
      axios
        .put(url, model)
        .then((response) => {
          setLoading(false);
          getFieldSet();
          toast.success("Saved!");
        })
        .catch((error) => {
          setLoading(false);
          handleError(error, intl);
        });
    } else {
      setLoading(true);
      let url = "/excelreports/" + selectedReport + "/fieldset/";
      axios
        .post(url, model)
        .then((response) => {
          setLoading(false);
          getFieldSet();
          toast.success("Saved!");
        })
        .catch((error) => {
          setLoading(false);
          handleError(error, intl);
        });
    }
    setOpenSaveModal(false);
  };

  useEffect(() => {
    if (modalName !== "" && modalName !== undefined && modalName !== null) {
      var currentFieldSet = excelReportFiledsets.find(
        (x) => x.text == modalName
      );
      if (currentFieldSet != null) {
        setSelectedFieldset(currentFieldSet.value);
      }
    }
  }, [excelReportFiledsets]);

  useEffect(() => {
    if (
      selectedFieldset !== "" &&
      selectedFieldset !== undefined &&
      selectedFieldset !== null
    ) {
      getFieldsByFieldSet();
    } else {
      setChosenColumns([]);
      if (
        selectedReport !== "" &&
        selectedReport !== undefined &&
        selectedReport !== null
      ) {
        getFields();
      }
    }
  }, [selectedFieldset]);

  const customList = (title, items) => (
    <Card>
      <CardHeader
        sx={{ px: 2, py: 1 }}
        avatar={
          <Checkbox
            onClick={handleToggleAll(items)}
            checked={
              numberOfChecked(items) === items.length && items.length !== 0
            }
            indeterminate={
              numberOfChecked(items) !== items.length &&
              numberOfChecked(items) !== 0
            }
            disabled={items.length === 0}
            inputProps={{
              "aria-label": intl.formatMessage({
                id: "ExcelReports.AllItemsSelected",
              }),
            }}
          />
        }
        title={title}
        subheader={`${numberOfChecked(items)}/${
          items.length
        } ${intl.formatMessage({ id: "ExcelReports.Selected" })}`}
      />
      <Divider />
      <List
        sx={{
          width: 350,
          height: tableHeight,
          bgcolor: "background.paper",
          overflow: "auto",
        }}
        dense
        component="div"
        role="list"
      >
        {items.map((value) => {
          const labelId = `transfer-list-all-item-${value}-label`;

          return (
            <ListItem
              key={value}
              role="listitem"
              button
              onClick={handleToggle(value)}
              className={
                checked.indexOf(value) !== -1
                  ? "apeVeryLigthBlueBackground"
                  : ""
              }
            >
              <ListItemText id={labelId} primary={`${value}`} />
            </ListItem>
          );
        })}
      </List>
    </Card>
  );

  const handleDownloadReport = () => {
    window.open(downloadLink, "_blank");
  };

  const handleFieldSetChange = (e) => {
    let currentFieldSet = excelReportFiledsets.find((x) => x.value == e);
    setFieldSetCanChange(currentFieldSet != null && currentFieldSet != undefined ? currentFieldSet.canChange : true);
    setSelectedFieldset(e);
  }

  return (
    <Box>
      <PageHeader title={intl.formatMessage({ id: "ExcelReports.Title" })} />

      <Box sx={{ mt: 0.5 }}>
        <PageForm
          adjustHeightFunc={handletrasitionEnd}
          form={
            <form>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={1.6}>
                  <CustomInput
                    labelText={intl.formatMessage({ id: "General.IncludeClosed" })}
                    type="switch"
                    valueRef={includeClosed}
                    setValue={setIncludeClosed}
                    inputCol={3}
                    textCol={9}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={1.8}>
                  <CustomInput
                    labelText={intl.formatMessage({ id: "RA.Year" })}
                    type="number"
                    value={year}
                    setValue={setYear}
                    inputCol={7}
                    textCol={5}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <CustomInput
                    labelText={intl.formatMessage({ id: "RA.Department" })}
                    type="multiselect"
                    valueRef={selectedDepartments}
                    selectItems={departments}
                    setValue={setSelectedDepartments}
                    textCol={4}
                    inputCol={8}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={1.8}>
                  <CustomInput
                    labelText={intl.formatMessage({ id: "RA.Number" })}
                    type="number"
                    value={number}
                    setValue={setNumber}
                    inputCol={6}
                    textCol={6}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={1.8}>
                  <CustomInput
                    labelText={intl.formatMessage({ id: "RA.Split" })}
                    type="number"
                    value={split}
                    setValue={setSplit}
                    inputCol={7}
                    textCol={5}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <CustomInput
                    labelText={intl.formatMessage({
                      id: "ExcelReports.InboundDelivery",
                    })}
                    type="text"
                    value={inboundDelivery}
                    setValue={setInboundDelivery}
                    textCol={4}
                    inputCol={8}
                  />
                </Grid>
              </Grid>
              <Grid container mt={1} spacing={2}>
                <Grid item md={2}>
                  <CustomInput
                    labelText={intl.formatMessage({ id: "General.Sku" })}
                    type="text"
                    value={sku}
                    setValue={setSku}
                    inputCol={8}
                    textCol={3}
                  />
                </Grid>
                <Grid item md={2}>
                  <CustomInput
                    labelText={intl.formatMessage({ id: "General.Model" })}
                    type="text"
                    value={styleCode}
                    setValue={setStyleCode}
                    inputCol={8}
                    textCol={3}
                  />
                </Grid>
                <Grid item md={2}>
                  <CustomInput
                    labelText={intl.formatMessage({ id: "General.Part" })}
                    type="text"
                    value={fabricCode}
                    setValue={setFabricCode}
                    inputCol={8}
                    textCol={3}
                  />
                </Grid>
                <Grid item md={2}>
                  <CustomInput
                    labelText={intl.formatMessage({ id: "General.Color" })}
                    type="text"
                    value={colorCode}
                    setValue={setColorCode}
                    inputCol={8}
                    textCol={3}
                  />
                </Grid>
                <Grid item md={4}>
                  <CustomInput
                    labelText={intl.formatMessage({
                      id: "ExcelReports.Outcome",
                    })}
                    type="multiselect"
                    valueRef={selectedOutcomes}
                    selectItems={outcomes}
                    setValue={setSelectedOutcomes}
                    inputCol={9}
                    textCol={3}
                  />
                </Grid>
              </Grid>
              <Grid container mt={1} spacing={2}>
                <Grid item md={3}>
                  <CustomInput
                    labelText={intl.formatMessage({
                      id: "ExcelReports.CreationDateFrom",
                    })}
                    type="date"
                    valueRef={creationFromDate}
                    setValue={setCreationFromDate}
                    inputCol={7}
                    textCol={5}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <CustomInput
                    labelText={intl.formatMessage({ id: "ExcelReports.To" })}
                    type="date"
                    valueRef={creationToDate}
                    setValue={setCreationToDate}
                    inputCol={7}
                    textCol={2}
                  />
                </Grid>
                <Grid item xs={false} sm={false} md={1} display={{ xs: "none", md: "block" }} />
                <Grid item xs={12} sm={6} md={3}>
                  <CustomInput
                    labelText={intl.formatMessage({
                      id: "ExcelReports.SAPClient",
                    })}
                    type="multiselect"
                    valueRef={selectedSAPCustomers}
                    selectItems={SAPCustomers}
                    setValue={setSelectedSAPCustomers}
                    inputCol={7}
                    textCol={5}
                    classLabel={withStealthFlow ? "apeDisabledColor" : ""}
                    disabled={withStealthFlow}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <CustomInput
                    labelText={intl.formatMessage({
                      id: "RASearch.SAPSender",
                    })}
                    type="text"
                    value={sapSender}
                    setValue={setSapSender}
                    inputCol={7}
                    textCol={5}
                  />
                </Grid>
              </Grid>

              <Grid container mt={1} spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                  <CustomInput
                    labelText={intl.formatMessage({
                      id: "ExcelReports.CheckInDateFrom",
                    })}
                    type="date"
                    valueRef={checkInFromDate}
                    setValue={setCheckInFromDate}
                    inputCol={7}
                    textCol={5}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <CustomInput
                    labelText={intl.formatMessage({ id: "ExcelReports.To" })}
                    type="date"
                    valueRef={checkInToDate}
                    setValue={setCheckInToDate}
                    inputCol={7}
                    textCol={2}
                  />
                </Grid>
                <Grid item xs={false} sm={false} md={1} display={{ xs: "none", md: "block" }} />
                <Grid item xs={12} sm={6} md={3}>
                  <CustomInput
                    labelText={intl.formatMessage({
                      id: "ExcelReports.STEALTHClient",
                    })}
                    type="multiselect"
                    valueRef={selectedSTEALTHCustomers}
                    selectItems={STEALTHCustomers}
                    setValue={setSelectedSTEALTHCustomers}
                    inputCol={7}
                    textCol={5}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <CustomInput
                    labelText={intl.formatMessage({
                      id: "General.JDALocation",
                    })}
                    type="text"
                    value={jdaLocation}
                    setValue={setJdaLocation}
                    textCol={5}
                    inputCol={7}
                  />
                </Grid>
              </Grid>

              <Grid container mt={1} spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                  <CustomInput
                    labelText={intl.formatMessage({
                      id: "ExcelReports.EndQCDateFrom",
                    })}
                    type="date"
                    valueRef={endQCFromDate}
                    setValue={setEndQCFromDate}
                    inputCol={7}
                    textCol={5}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <CustomInput
                    labelText={intl.formatMessage({ id: "ExcelReports.To" })}
                    type="date"
                    valueRef={endQCToDate}
                    setValue={setEndQCToDate}
                    inputCol={7}
                    textCol={2}
                  />
                </Grid>
                <Grid item xs={false} sm={false} md={1} display={{ xs: "none", md: "block" }} />
                <Grid item xs={12} sm={6} md={3}>
                  <CustomInput
                    labelText={intl.formatMessage({ id: "RA.State" })}
                    type="multiselect"
                    valueRef={selectedStates}
                    selectItems={states}
                    setValue={setselectedStates}
                    textCol={5}
                    inputCol={7}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <CustomInput
                    labelText={intl.formatMessage({ id: "General.Country" })}
                    type="select"
                    valueRef={selectedCountry}
                    selectItems={countries}
                    setValue={setSelectedCountry}
                    textCol={5}
                    inputCol={7}
                  />
                </Grid>
              </Grid>

              <Grid container mt={1} spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                  <CustomInput
                    labelText={intl.formatMessage({
                      id: "ExcelReports.PutToStockDateFrom",
                    })}
                    type="date"
                    valueRef={closingFromDate}
                    setValue={setClosingFromDate}
                    inputCol={7}
                    textCol={5}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <CustomInput
                    labelText={intl.formatMessage({ id: "ExcelReports.To" })}
                    type="date"
                    valueRef={closingToDate}
                    setValue={setClosingToDate}
                    inputCol={7}
                    textCol={2}
                  />
                </Grid>
                <Grid item xs={false} sm={false} md={1} display={{ xs: "none", md: "block" }} />
                <Grid item xs={12} sm={6} md={3}>
                  <CustomRadioButton
                    labelText={intl.formatMessage({
                      id: "RASearch.DossierAge",
                    })}
                    setValue={(e) => {
                      handleDossierAgeChange(e);
                    }}
                    valueRef={dossierAge}
                    textCol={5}
                    inputCol={7}
                    onClickRedButton={handleCheckRadioRed}
                    onClickOrangeButton={handleCheckRadioOrange}
                    onClickWhiteButton={handleCheckRadioWhite}
                    checkRadioRed={checkRadioRed}
                    checkRadioOrange={checkRadioOrange}
                    checkRadioWhite={checkRadioWhite}
                  />
                </Grid>
              </Grid>
            </form>
          }
        />
      </Box>
     
     <Box id="form1" sx={{ mt: 2 }}>
      <Grid container>
        <Grid item xs={12} sm={6}>
          <CustomInput
            labelText={intl.formatMessage({ id: "ExcelReports.Title" })}
            type="select"
            valueRef={selectedReport}
            selectItems={excelReports}
            setValue={setSelctedReport}
            inputCol={9}
            textCol={3}
          />
        </Grid>
      </Grid>
      <Grid container sx={{ mt: 1 }}>
        <Grid item xs={12} sm={6}>
          <CustomInput
            labelText={intl.formatMessage({ id: "ExcelReports.FieldSet" })}
            type="select"
            valueRef={selectedFieldset}
            selectItems={excelReportFiledsets}
            setValue={handleFieldSetChange}
            inputCol={9}
            textCol={3}
          />
        </Grid>
      </Grid>
    </Box>

    <Box sx={{ mt: 3 }}>
      <Grid
        container
        spacing={2}
        justifyContent="center"
        alignItems="center"
        direction={{ xs: "column", sm: "row" }}
      >
        <Grid item xs={12} sm="auto" sx={{ width: { xs: "100%", sm: "auto" } }}>
          {customList(
            intl.formatMessage({ id: "ExcelReports.AllColumns" }),
            availableColumns
          )}
        </Grid>
        <Grid item xs={12} sm="auto">
          <Grid
            container
            direction={{ xs: "row", sm: "column" }}
            justifyContent="center"
            alignItems="center"
          >
            <Button
              sx={{ my: { xs: 0, sm: 0.5 }, mx: { xs: 0.5, sm: 0 } }}
              variant="outlined"
              size="small"
              onClick={handleCheckedRight}
              disabled={leftChecked.length === 0 || !fieldSetCanChange}
              aria-label="move selected right"
            >
              <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
                &gt;
              </Box>
              <Box component="span" sx={{ display: { xs: "inline", sm: "none" } }}>
                &darr;
              </Box>
            </Button>
            <Button
              sx={{ my: { xs: 0, sm: 0.5 }, mx: { xs: 0.5, sm: 0 } }}
              variant="outlined"
              size="small"
              onClick={handleCheckedLeft}
              disabled={rightChecked.length === 0 || !fieldSetCanChange}
              aria-label="move selected left"
            >
              <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
                &lt;
              </Box>
              <Box component="span" sx={{ display: { xs: "inline", sm: "none" } }}>
                &uarr;
              </Box>
            </Button>
          </Grid>
        </Grid>
        <Grid item xs={12} sm="auto" sx={{ width: { xs: "100%", sm: "auto" } }}>
          {customList(
            intl.formatMessage({ id: "ExcelReports.ChosenColumns" }),
            chosenColumns
          )}
        </Grid>
      </Grid>
    </Box>

    <Grid container spacing={2} sx={{ mt: 2 }}>
      <Grid item xs={12} sm={1.5} order={{ xs: 1, sm: 1 }}>
        {chosenColumns.length == 0 ? (
          <Button
            variant="contained"
            sx={{ width: "100%" }}
            className="apeLigthBlueBackground"
            startIcon={<SaveIcon />}
            disabled
          >
            {intl.formatMessage({ id: "General.Save" })}
          </Button>
        ) : (
          <Button
            variant="contained"
            sx={{ width: "100%" }}
            className="apeLigthBlueBackground"
            startIcon={<SaveIcon />}
            onClick={handleSave}
            disabled={!fieldSetCanChange}
          >
            {intl.formatMessage({ id: "General.Save" })}
          </Button>
        )}
      </Grid>
      <Grid item xs={false} sm={8.5} sx={{ display: { xs: "none", sm: "block" } }} />
      <Grid item xs={12} sm={1.5} order={{ xs: 2, sm: 2 }}>
        {selectedFieldset == "" ? (
          <Button
            variant="contained"
            sx={{ width: "100%" }}
            className="apeLigthBlueBackground"
            startIcon={<DownloadIcon />}
            disabled
          >
            {intl.formatMessage({ id: "ExcelReports.Run" })}
          </Button>
        ) : (
          <Button
            variant="contained"
            sx={{ width: "100%" }}
            className="apeLigthBlueBackground"
            startIcon={<DownloadIcon />}
            onClick={handleRun}
          >
            {intl.formatMessage({ id: "ExcelReports.Run" })}
          </Button>
        )}
      </Grid>
    </Grid>

      <Modal
        open={openSaveModal}
        onClose={handleCloseSaveModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <Box>
            <Grid container>
              <Grid
                item
                sm={12}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "left",
                  p: 1,
                }}
              >
                <FormLabel>
                  {intl.formatMessage({ id: "ExcelReports.FieldSet" })}
                </FormLabel>
              </Grid>
              <Grid item sm={12} display="flex" sx={{ p: 1 }}>
                <Input
                  type="text"
                  sx={{ width: "100%" }}
                  value={modalName}
                  onChange={handleChangeModalName}
                ></Input>
              </Grid>
            </Grid>
          </Box>
          <Grid container>
            <Grid item sm={8.5}></Grid>
            <Grid item sm={3.5}>
              <Button
                variant="contained"
                sx={{ width: "100%" }}
                className="apeLigthBlueBackground"
                startIcon={<SaveIcon />}
                onClick={handleSaveModal}
              >
                {intl.formatMessage({ id: "General.Save" })}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>

      <DownloadExcelModal
        downloadLink={downloadLink}
        openDownloadModal={openDownloadModal}
      ></DownloadExcelModal>
    </Box>
  );
};

export default ExcelReports;
